import React, { CSSProperties } from "react";

import {
  Imprint,
  HeaderWrapper,
  HeaderRow,
  HeaderSpacer,
  HeaderLogo,
  HeaderMenu,
  LogoWrapper,
} from "./styles.Header";

import LogoDesktop from "../../assets/SiCLogo.svg";
import LogoMobile from "../../assets/SiCLogoMobile.svg";

interface LegalLinksProps {
  isFloating?: boolean;
  className?: string;
  style?: CSSProperties;
}

export const LegalLinks: React.FC<LegalLinksProps> = ({
  isFloating = true,
  className,
  style,
}) => {
  return (
    <Imprint isFloating={isFloating} className={className} style={style}>
      <ul>
        <li>
          <a
            target="_blank"
            href="https://www.br.de/unternehmen/service/impressum/index.html"
          >
            Imprint
          </a>
        </li>
        <li>
          <a
            target="_blank"
            href="https://www.br.de/unternehmen/service/impressum/impressum-datenschutzerklaerung-unternehmen-v2-100.html"
          >
            Privacy
          </a>
        </li>
        <li>
          <a href="#authors-credits">Credits</a>
        </li>
      </ul>
    </Imprint>
  );
};

interface HeaderProps {
  showLogo?: boolean;
  showLegal?: boolean;
}

export const Header: React.FC<HeaderProps> = ({
  showLogo = true,
  showLegal = true,
  children,
}) => {
  return (
    <HeaderWrapper>
      <HeaderRow>
        <HeaderSpacer />
        {showLogo && <HeaderLogo src={LogoDesktop} alt="Science in Context" />}
        <HeaderMenu>{children}</HeaderMenu>
      </HeaderRow>
      {showLegal && <LegalLinks />}
    </HeaderWrapper>
  );
};

export const Logo: React.FC = () => {
  return (
    <LogoWrapper>
      <img src={LogoMobile} className={"LogoMobile"} alt="Science in Context" />
      <img
        src={LogoDesktop}
        className={"LogoDesktop"}
        alt="Science in Context"
      />
      <h1>Generating Climate Fact Boxes with AI</h1>
    </LogoWrapper>
  );
};
